import React, { useState } from "react";
import { Button, Grid, CircularProgress, Alert } from "@mui/material";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import LNSTable from "../components/Tables/LNSTable";
import LNSAddDialog from "../components/Dialogs/lnsAdd";
import ApplicationsTable from "../components/Tables/ApplicationsTable";
import ApplicationAddDialog from "../components/Dialogs/applicationAdd";
import PageTitle from "../components/Layout/PageTitle";
import { useLnss } from "../hooks/useLns";
import { useApplications } from "../hooks/useApplications";

function LNSs() {
  const [lnsAddDialogOpen, setLNSAddDialogOpen] = useState(false);
  const [applicationAddDialogOpen, setApplicationAddDialogOpen] =
    useState(false);

  const { data: lnss, isLoading: lnssLoading, error: lnssError } = useLnss();
  const {
    data: applications,
    isLoading: appsLoading,
    error: appsError,
  } = useApplications();

  const isLoading = lnssLoading || appsLoading;
  const hasError = lnssError || appsError;

  if (isLoading) {
    return (
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} textAlign="center">
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  if (hasError) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Alert severity="error">
            Failed to load data:{" "}
            {(lnssError || appsError)?.message || "Unknown error"}
          </Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={1}>
        <PageTitle title="LNSs">
          <Button
            variant="outlined"
            onClick={() => {
              setLNSAddDialogOpen(true);
            }}
          >
            Add LNS
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setApplicationAddDialogOpen(true);
            }}
          >
            Add Application
          </Button>
        </PageTitle>
        <Grid item xs={12}>
          <LNSTable lnss={lnss} />
        </Grid>
        <Grid item xs={12}>
          <ApplicationsTable applications={applications} />
        </Grid>
      </Grid>
      <LNSAddDialog
        open={lnsAddDialogOpen}
        handleClose={() => {
          setLNSAddDialogOpen(false);
          // React Query will automatically refetch data
        }}
      />
      <ApplicationAddDialog
        open={applicationAddDialogOpen}
        handleClose={() => {
          setApplicationAddDialogOpen(false);
          // React Query will automatically refetch data
        }}
      />
    </>
  );
}

export default withAuthenticationRequired(LNSs);
